import useUserStore from "../../../storeModules/useUserStore";
import useBotControlStore from "../../../storeModules/useBotControlStore";
import findStep from "./findStep";
import { getCep } from "../../../api/requests";
import noConnectionHandler from "../../../utils/noConnectionHandler";

const cepErrorSteps = [
  {
    name: "erro_cep",
    sender: "bot",
    text: "",
    isWaitingForFetch: true,
    action: () => {
      const { cepErrorAt } = useUserStore.getState();
      const nextStep =
        cepErrorAt === "cep-first-input"
          ? findStep("agradecimento_cep").index
          : cepErrorAt === "update"
          ? findStep("revisao_dados_pessoais").index
          : findStep("revisao_dados_pessoais").index;
      const { logradouro, bairro } = useUserStore.getState().contrato;

      if (!logradouro) {
        useBotControlStore.setState({
          currentStep: findStep("informa_logradouro").index,
        });

        return;
      }

      if (!bairro) {
        useBotControlStore.setState({
          currentStep: findStep("informa_bairro").index,
        });

        return;
      }

      useBotControlStore.setState({
        currentStep: nextStep,
      });
    },
  },
  {
    name: "informa_logradouro",
    sender: "bot",
    inputType: "userStreet",
    text: "Insira o nome da <b>rua.</b>",
    isWaitingForFetch: true,
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("erro_cep").index,
      });
    },
  },
  {
    name: "informa_bairro",
    sender: "bot",
    inputType: "userNeighborhood",
    text: "Insira o nome do <b>bairro.</b>",
    isWaitingForFetch: true,
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("erro_cep").index,
      });
    },
  },
  {
    name: "cep_nao_encontrado",
    sender: "bot",
    text: "<b>Ops!</b> não encontrei esse CEP.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("tentar_cep_novamente").index,
      });
    },
  },
  {
    name: "tentar_cep_novamente",
    sender: "bot",
    text: `<b>Corrija o CEP</b> para tentar novamente.`,
    inputType: "userCep",
    action: () => {
      setTimeout(() => {
        noConnectionHandler().then(() => {
          getCep();
        });
      }, 500);
    },
  },
];

export default cepErrorSteps;
